/*!
    * @product/scmp-sdk 1.1.8
    * built by undefined
  */
import{i as t}from"./chunk-PPQ5V4EU.js";var r=()=>{let{acquisition:{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}}=t();return{getPersonalizationByExperimentId:e,getVariantByExperimentId:i,uiTestingState:o}};export{r as a};
//# sourceMappingURL=chunk-LT3DKZFE.js.map
